import React from "react";

const steps = [
  {
    step: "01",
    title: "Find & Enroll Course",
    description: "Browse courses and enroll in the one that fits your goals.",
    icon: "/assets/img/icon/learn.svg",
  },
  {
    step: "02",
    title: "Start Your Course",
    description: "Learn with structured content and expert instructors.",
    icon: "/assets/img/icon/course-2.svg",
  },
  {
    step: "03",
    title: "Become Master",
    description: "Gain skills, confidence, and apply knowledge in real life.",
    icon: "/assets/img/icon/expert.svg",
  },
];

function ProcessSection() {
  return (
    <section className="process-area py-120">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div className="col-lg-7 mx-auto text-center mb-50">
            <span className="site-title-tagline">Working Process</span>
            <h2 className="site-title">
              Easy Steps for{" "}
              <span className="text-gradient">Start Learning</span>
            </h2>
          </div>
        </div>

        {/* Steps */}
        <div className="row g-4">
          {steps.map((item) => (
            <div className="col-md-6 col-lg-4" key={item.step}>
              <div className="process-item">
                <span className="process-count">{item.step}</span>

                <div className="process-icon">
                  <img src={item.icon} alt={item.title} />
                </div>

                <div className="process-content">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
